/**
 * Export aria attribute names.
 *
 * @author    Naotoshi Fujita
 * @copyright Naotoshi Fujita. All rights reserved.
 */

/**
 * Attribute name for aria-current.
 *
 * @type {string}
 */
export const ARIA_CURRENRT = 'aria-current';

/**
 * Attribute name for aria-control.
 *
 * @type {string}
 */
export const ARIA_CONTROLS = 'aria-controls';

/**
 * Attribute name for aria-control.
 *
 * @type {string}
 */
export const ARIA_LABEL = 'aria-label';

/**
 * Attribute name for aria-labelledby.
 *
 * @type {string}
 */
export const ARIA_LABELLEDBY = 'aria-labelledby';

/**
 * Attribute name for aria-hidden.
 *
 * @type {string}
 */
export const ARIA_HIDDEN = 'aria-hidden';

/**
 * Attribute name for tab-index.
 *
 * @type {string}
 */
export const TAB_INDEX = 'tabindex';